class LocalSellebrityMenu extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-ls-menu-button]');
    this.panel = this.querySelector('[data-ls-mobile-menu]');
    if (!this.button || !this.panel) return;
    this.button.addEventListener('click', () => this.toggle());
    this.panel.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => this.close()));
    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') this.close();
    });
  }

  toggle() {
    const open = !this.panel.hasAttribute('open');
    this.panel.toggleAttribute('open', open);
    this.button.setAttribute('aria-expanded', String(open));
  }

  close() {
    this.panel.removeAttribute('open');
    this.button.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('local-sellebrity-menu')) {
  customElements.define('local-sellebrity-menu', LocalSellebrityMenu);
}
